import { gql } from '@apollo/client';

export const CONTACT = gql`
    mutation Contact($input: ContactInput) {
        contact(input: $input) {
            success
        }
    }
`;